var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "mt-4 mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "col-md-8 mt-4 d-flex align-items-start justify-content-between"
            },
            [
              _c("back-arrow", { attrs: { title: _vm.$t("Menu.my.annonces") } })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "transition-group",
                {
                  attrs: {
                    appear: "",
                    name: "listCustomTransition",
                    tag: "div"
                  }
                },
                [
                  _c(
                    "div",
                    { key: "homePlaceHolder-draft", staticClass: "mt-4" },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h1", { staticClass: "page-subtitle" }, [
                              _vm._v(_vm._s(_vm.$t("annonce.my.draft")))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "other-annonces card-container row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: "homePlaceHolder-toValidate", staticClass: "mt-4" },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h1", { staticClass: "page-subtitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "annonce.my.ongoing.validation.annonce"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "other-annonces card-container row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: "homePlaceHolder-validated", staticClass: "mt-4" },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h1", { staticClass: "page-subtitle" }, [
                              _vm._v(
                                _vm._s(_vm.$t("annonce.my.validated.annonce"))
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "other-annonces card-container row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isForHome: true,
                              isGradient: false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "transition-group",
                { attrs: { name: "listCustomTransition" } },
                _vm._l(_vm.annonceData, function(annonceGroup, index) {
                  return _c(
                    "div",
                    { key: index + "-annonceGroup", staticClass: "mt-4" },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c("h1", { staticClass: "page-subtitle" }, [
                              _vm._v(
                                _vm._s(
                                  annonceGroup.isI18n
                                    ? _vm.$t(annonceGroup.annonceType)
                                    : _vm.$t(annonceGroup.title)
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        annonceGroup.savedSearchDescription
                          ? _c(
                              "div",
                              { staticClass: "mt-2 main-grey-medium-color" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "annonce.home.savedSearch.with.filters"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      annonceGroup.savedSearchDescription
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      annonceGroup.annonces.length > 0
                        ? [
                            annonceGroup.annonceType === "VALIDATED"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "other-annonces cards-container"
                                  },
                                  _vm._l(annonceGroup.annonces, function(
                                    annonce
                                  ) {
                                    return _c("annonce-card-image-top", {
                                      key: annonce.serverId,
                                      staticClass: "cursor-pointer",
                                      attrs: {
                                        annonce: annonce,
                                        "from-my-annonce": ""
                                      }
                                    })
                                  }),
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "last-annonces cards-container"
                                  },
                                  _vm._l(annonceGroup.annonces, function(
                                    annonce
                                  ) {
                                    return _c("annonce-card-image-left", {
                                      key: annonce.serverId,
                                      staticClass: "cursor-pointer",
                                      attrs: {
                                        annonce: annonce,
                                        "from-my-annonce": ""
                                      }
                                    })
                                  }),
                                  1
                                )
                          ]
                        : [
                            _c("div", { staticClass: "card-container" }, [
                              _c("div", { staticClass: "d-flex" }, [
                                _c("div", { staticClass: "p-3" }, [
                                  _c("img", {
                                    staticClass: "empty-state-img-home",
                                    attrs: {
                                      src: require("@/assets/images/b122/img-confused.png"),
                                      alt: "no result"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "empty-state-text" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.emptyStateText(
                                            annonceGroup.annonceType
                                          )
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ])
                            ])
                          ]
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bd0cacc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bd0cacc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyAnnonce.vue
// module id = mjc8
// module chunks = 0